import { render } from "./MCampaignPopup.vue?vue&type=template&id=188fc81f&scoped=true&ts=true"
import script from "./MCampaignPopup.vue?vue&type=script&lang=ts"
export * from "./MCampaignPopup.vue?vue&type=script&lang=ts"

import "./MCampaignPopup.vue?vue&type=style&index=0&id=188fc81f&lang=scss&scoped=true"
import "./MCampaignPopup.vue?vue&type=style&index=1&id=188fc81f&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188fc81f"]])

export default __exports__